import * as THREE from 'three';
import { CSS2DObject } from 'three/examples/jsm/renderers/CSS2DRenderer';

export class GeopostProjectionGroup extends THREE.Group {
    public label: CSS2DObject;
    public mesh: THREE.Mesh;

    static getGeometry(height: number, width: number, type: string) {
        if (type === 'cylinder') {
            const geom = new THREE.CylinderGeometry(width * 0.04, width * 0.04, height, 20, 32);
            return geom;
        }
        else if (type === 'sphere') {
            return new THREE.SphereGeometry(width * 0.04, 32, 16);
        }
        else {
            return new THREE.CylinderGeometry(width, width, height, 20, 32);
        }
    }

    constructor (origin: number, end: number, width: number, geomType: string, color: string, xPos: number, zPos: number, labelText: string, rotationReference: THREE.Vector3 | null = null) {
        super();
        const newXPosition = xPos;
        const newZPosition = zPos;

        const labelDiv = document.createElement('div');
        labelDiv.className = '';
        labelDiv.style.backgroundColor = 'transparent';
        labelDiv.style.color = 'white';
        labelDiv.style.fontSize = '20px';
        //labelDiv.style.marginLeft = '120px';
        labelDiv.style.textShadow = '2px 2px 3px black';
        labelDiv.textContent = ( labelText ?? 'NO LABEL').trim();

        const label = new CSS2DObject(labelDiv);
        label.position.set(newXPosition, origin * -1, newZPosition);
        this.add(label);
        label.visible = false;
        this.label = label;

        const wordsNumber = labelDiv.textContent.length;
        if ( wordsNumber === 1) {
            label.center.set(-0.4, 0.5);
        } else if (wordsNumber === 2) {
            label.center.set(-0.25, 0.5);
        } else {
            label.center.set(-0.15, 0.5);
        }

        const geometry = GeopostProjectionGroup.getGeometry(Math.abs(end) - Math.abs(origin), width, geomType);
        const material = new THREE.MeshBasicMaterial({color: color});
        material.opacity = 0.5;
        material.transparent = true;

        const mesh = new THREE.Mesh(geometry, material);
        mesh.position.set(newXPosition, origin * -1, newZPosition);

        this.add(mesh);
        this.mesh = mesh;
        //mesh.rotateX(Math.PI / 2);
        if (!!rotationReference) {
            mesh.rotateOnAxis(this.mesh.position, (mesh.position.angleTo(rotationReference)));
        }
        mesh.renderOrder = -4;

    }
}